module.exports = "tr.list { \n    height: auto;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/latest-transactions/latest-transactions.component.css
// module id = ./src/app/latest-transactions/latest-transactions.component.css
// module chunks = main